import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBookingReference, IBookingReferenceState } from "./bookingreferenceModel";
import { getAllBookingReference } from "./services/bookingreference.services";

const initialState: IBookingReferenceState = {
  loading: false,
  error: "",
  BookingReferenceID: null,
  BookingReferenceList: [],
  FilterBookingReference: {
    RoomName: "",
    URL: "",
  },
};

const bookingreferenceSlice = createSlice({
  name: "bookingreference",
  initialState,
  reducers: {
    setBookingReferenceID: (state, action) => {
      state.BookingReferenceID = action.payload;
    },
    clearBookingReferenceID: (state) => {
      state.BookingReferenceID = initialState.BookingReferenceID;
    },
    setFilterBookingReference: (state, action) => {
      state.FilterBookingReference = action.payload;
    },
    clearFilterBookingReference: (state) => {
      state.FilterBookingReference = initialState.FilterBookingReference;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBookingReference.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBookingReference.fulfilled,
      (state, action: PayloadAction<IBookingReference[]>) => {
        state.loading = false;
        state.BookingReferenceList = action.payload || [];
      }
    );
    builder.addCase(getAllBookingReference.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BookingReferenceList = [];
    });
  },
});

export const {
  clearBookingReferenceID,
  setBookingReferenceID,
  clearFilterBookingReference,
  setFilterBookingReference,
} = bookingreferenceSlice.actions;
export default bookingreferenceSlice.reducer;
